module.exports = "/assets/landing-rc/promo/delice-logo.jpg?pQMk/12";